import { render, staticRenderFns } from "./CreatedAt.vue?vue&type=template&id=35fbeca2&"
import script from "./CreatedAt.vue?vue&type=script&lang=js&"
export * from "./CreatedAt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports